module.exports = __webpack_public_path__ + "img/arrow-left.6d1759f3.svg";